import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enAlerts from '@/locales/en/alerts.json';
import enAuth from '@/locales/en/auth.json';
import enBilling from '@/locales/en/billing.json';
import enChecklist from '@/locales/en/checklist.json';
import enCommon from '@/locales/en/common.json';
import enCpoAnalytics from '@/locales/en/cpoAnalytics.json';
import enHelpdesk from '@/locales/en/helpdesk.json';
import enOda from '@/locales/en/oda.json';
import enQrPayment from '@/locales/en/qrPayment.json';
import enSessionSchedules from '@/locales/en/sessionSchedules.json';
import nlAlerts from '@/locales/nl/alerts.json';
import nlAuth from '@/locales/nl/auth.json';
import nlBilling from '@/locales/nl/billing.json';
import nlChecklist from '@/locales/nl/checklist.json';
import nlCommon from '@/locales/nl/common.json';
import nlCpoAnalytics from '@/locales/nl/cpoAnalytics.json';
import nlHelpdesk from '@/locales/nl/helpdesk.json';
import nlOda from '@/locales/nl/oda.json';
import nlQrPayment from '@/locales/nl/qrPayment.json';
import nlSessionSchedules from '@/locales/nl/sessionSchedules.json';

import { LOCALE_STORAGE_KEY } from './constants';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    cpoAnalytics: enCpoAnalytics,
    qrPayment: enQrPayment,
    billing: enBilling,
    oda: enOda,
    helpdesk: enHelpdesk,
    alerts: enAlerts,
    checklist: enChecklist,
    sessionSchedules: enSessionSchedules,
  },
  nl: {
    common: nlCommon,
    auth: nlAuth,
    cpoAnalytics: nlCpoAnalytics,
    qrPayment: nlQrPayment,
    billing: nlBilling,
    oda: nlOda,
    helpdesk: nlHelpdesk,
    alerts: nlAlerts,
    checklist: nlChecklist,
    sessionSchedules: nlSessionSchedules,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: [
      'common',
      'auth',
      'cpoAnalytics',
      'qrPayment',
      'billing',
      'oda',
      'helpdesk',
      'alerts',
      'checklist',
      'sessionSchedules',
    ],
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl'],

    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'locale',
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },

    interpolation: { escapeValue: false },
  });

export default i18n;
